"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedOfferingsFilterType = void 0;
var SelectedOfferingsFilterType;
(function (SelectedOfferingsFilterType) {
    SelectedOfferingsFilterType["ALL"] = "ALL";
    SelectedOfferingsFilterType["SPECIFIC"] = "SPECIFIC";
    SelectedOfferingsFilterType["FIRST"] = "FIRST";
})(SelectedOfferingsFilterType = exports.SelectedOfferingsFilterType || (exports.SelectedOfferingsFilterType = {}));
//# sourceMappingURL=selected-resources.js.map